import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLinkWithHref } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { BtCostPercentageService } from '@app/core/services/bt-cost-percentage.service';
import { EventCardComponent } from './event-card.component';

@NgModule({
  imports: [CommonModule, TranslateModule, MatIconModule, RouterLinkWithHref],
  declarations: [EventCardComponent],
  exports: [EventCardComponent],
  providers: [BtCostPercentageService],
})
export class EventCardComponentModule {}
